const elianUrlSniff = 'eliane';
const elianDestination = '/posts';

const initElianeHome = function() {
    console.log('Init Eliane home...');

    const body = document.querySelector('body');
    const i4Site = document.querySelector('.i4-site');

    i4Site.style.display = 'none';

    const div = document.createElement('div');
    document.body.appendChild(div);

    div.style.position = 'fixed';
    div.style.top = '0';
    div.style.left = '0';
    div.style.width = '100vw';
    div.style.height = '100vh';
    div.style.cursor = 'pointer';
    div.addEventListener('click', function () {
        window.location.href = elianDestination;
    });

    body.style.overflow = 'hidden';
};

if (window.location.href.indexOf(elianUrlSniff) > -1 && (window.location.pathname === '/' || window.location.pathname === '/home')) {
    window.addEventListener('DOMContentLoaded', initElianeHome);
}

